var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPesticideAutocompleteIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42656 7.94569C6.11965 11.2341 2.59362 11.9962 0.861252 11.915L0.112075 11.8798L0.182335 10.3815L0.931511 10.4166C2.3919 10.4851 5.72478 9.76063 7.64635 6.37331C5.72049 2.89528 2.34151 2.15527 0.868213 2.22479L0.119047 2.26015L0.0483398 0.761814L0.797506 0.726461C2.54929 0.643794 6.12129 1.42477 8.43522 4.79699C10.6746 0.713268 14.4803 0.423653 16.2732 0.885507L16.9994 1.07261L16.6252 2.52518L15.899 2.33808C14.5468 1.98975 11.2153 2.17079 9.4164 6.19217C9.38789 6.2559 9.35897 6.31896 9.32967 6.38136C9.34871 6.42286 9.36759 6.46464 9.38629 6.50672C11.1948 10.5754 14.5421 10.7561 15.8977 10.4047L16.6237 10.2165L17.0001 11.6685L16.2741 11.8567C14.4776 12.3225 10.6761 12.0312 8.42656 7.94569Z",
    fill: "#AFBDCA"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPesticideAutocompleteIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pesticideAutocompleteIcon.f2ee365f.svg";
export { ForwardRef as ReactComponent };